import React from 'react';
import { motion } from 'framer-motion';

const HoloCard = ({ children, className = '', delay = 0, title, action }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 15 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.4, delay, ease: "easeOut" }} 
      className={`relative bg-slate-900/30 backdrop-blur-md rounded-xl border border-cyan-500/10 shadow-[0_4px_20px_rgba(0,0,0,0.4)] overflow-hidden flex flex-col ${className}`}
    >
      {/* Branded Scanline Effect */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.25)_50%),linear-gradient(90deg,rgba(255,0,0,0.02),rgba(0,255,0,0.01),rgba(0,0,255,0.02))] z-0 bg-[length:100%_2px,3px_100%]"></div>
      
      {/* Frame Decor */}
      <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-cyan-500/20 rounded-tl-xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-cyan-500/20 rounded-br-xl pointer-events-none"></div>

      {(title || action) && (
        <div className="px-5 py-3.5 border-b border-cyan-900/30 flex justify-between items-center bg-cyan-950/10 z-10">
          {title && (
            <div className="flex items-center space-x-2">
              <div className="w-1 h-3 bg-cyan-500 rounded-full shadow-[0_0_8px_#06b6d4]"></div>
              <h3 className="text-cyan-200/80 font-bold tracking-widest text-[10px] uppercase">{title}</h3>
            </div>
          )}
          {action && <div className="flex items-center">{action}</div>}
        </div>
      )}
      
      <div className="p-5 flex-1 relative z-10 h-full">
        {children}
      </div>
    </motion.div>
  );
};

export default HoloCard;